import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import ReactDatatable from "@ashvin27/react-datatable";
import { Modal, Button } from "react-bootstrap";
import { getDateISOFormat, getPatientsubstring } from "../constants/globalLevelFunctions";
//import FooterSection from "../components/UI/FooterSection";
import axios from "axios";
import { CONFIG } from "../config/data";
import Spinner from "../components/UI/Spinner";
import DatePicker from "react-date-picker";
import InputField from "../components/UI/InputField";
import Validation from "../actions/Validation";
import { Popup } from "../components/UI/Popup";
import CheckboxOrRadioGroup from "../components/UI/CheckboxOrRadioGroup";
import Label from "../components/UI/Label";
import * as moment from "moment";
import {
  consultPsychiatristDoctor, getAllBusinessList, getCheckinDetails, getQEntryById, createNotification,
  UpdateQueueForCheckOut, sendemail, sendsms, updateclientappointmentstatus, searchBusiness, getDocByBusiness, getDocByBusinesswithspeciality
} from "../config/url.json";
import {
  stringToLabelValue,
  getKeyFromValue,
  getMaxIdOfRecords,
  calculate_age,
} from "../constants/globalLevelFunctions";
import Select from "react-select";
import { withRouter } from "react-router-dom";
import SpanField from "../components/UI/SpanField";
import TextArea from "../components/UI/TextArea";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer, toast } from 'react-toastify';
import Dnaspinner from '../components/UI/Dnaspinner';
function mapStateToProps(state) {
  return {
    appdata: state.AppData,
    userdata: state.AuthReducer.user,
    access_token: state.AuthReducer.access_token,
  };
}

function mapDispatchToProps(dispatch) {
  return {

  };
}
const education_level = ["Primary School", "Secondary School", "Graduate", "Post Graduate", "No Formal Education"];
const occupation = ["Student", "Employed", "Self-Employed", "Retired", "Unemployed"];
const triggers = ["Work Stress", "Family Conflict", "Health Concerns", "Financial Issues", "Relationship Problems", "Trauma", "others"];
const severity = ["Mild(Manageable)", "Moderate(Affects Daily Life)", "Severe(Significant Impact)"];
const stressors = ["Job Related", "Academic Pressure", "Family Issues", "Medical Concerns", "Social Isolation", "Other"];
const responsetotreatment = ["Very Effective", "Somewhat Effective", "No Change", "Worsened Condition"];
const type_of_conditions = ["Depression", "Anxiety", "Bipolar Disoder", "Schizophrenia", "Substance Abuse", "Other"];
const family_history = ["Yes", "No", "Unsure"];
const sitting_up = ["Before 6 Months", "6-12 Months", "After 12 Months"];
const speech_development = ["Before 1 Year", "1-2 Years", "After 2 Years"];
const personality_traits = ["Outgoing", "Reserved", "Detail-oriented", "Impulsive", "Creative", "Anxious"];
const recent_life_events = ["Job loss", "Death of Loved one", "Divorce/Breakup", "Relocation", "Trauma", "Health Issues"];
const ongoing_stressors = ["Financial", "Family related", "Work Stress", "Academic", "Health Related", "Social Isolation"];
const speech = ["Normal", "Slow", "Pressured", "Monotone", "Slurred"];
const thought_process = ["Logical", "Tangential", "Disorganised", "Racing Thoughts"];
const insight = ["No Insights-Denies having any disorder",
  "Poor Insights-Recognizes some symptoms but denies a disorder",
  "Fair Insight-Recognizes the disorder but not fully understand it",
  "Good Insight-Recognizes disorder & need for treatment",
  "Full Insight-Fully aware and actively seeks treatment",
];
const followup = ['followup'];
let eq_record = {
  id: "",
  education: "",
  specialization: "",
  university: "",
  completion_month: "",
  completion_year: "",
};

let cert_record = {
  education_level: "",
  specialization: "",
  valid_URL: "",
  certification_completion_month: "",
  certification_completion_year: "",
  valid_upto_month: "",
  valid_upto_year: "",
  id: "",
};

let experience_record = {
  hospital: "",
  ex_address: "",
  ex_city: "",
  ex_state: "",
  ex_country: "",
  ex_zipcode: "",
  experience_from: "",
  experience_to: "",
  id: "",
};
let socio_demographic_record = {
  id: "",
  education_level: "",
  occupation: "",
  living_situation: "",
};
class CaseHistorypsychiatrist extends Component {
  constructor(props) {
    super(props);
    this.config = {
      page_size: 10,
      length_menu: [10, 20, 50],
      button: {
        excel: false,
        print: false,
      },
      show_first: false,
      show_info: false,
      show_last: false,
      show_filter: false,
      show_length_menu: false,
    };

    this.state = {
      business_list: [],
      searchData: { business_name: "", speciality: "" },
      speciality_error: "",
      searchresults: {
        data: [],
      },
      successMessage: "",
      errorMessage: "",
      selected_doc: { value: "", label: "" },
      doctor_list: [],
      openModal: false,
      selected_doctor_appointment_detail_list: [],
      selected_doc_schedule_type: "",
      checkindetails: {},
      socio_demographic_details: [],
      queuein_data: {

      },
      caseHistory: {
        id: "",
        client_id: "",
        business_id: "",
        business_user_id: "",
        socio_demographic_formData: {
          education_level: "",
          occupation: "",
          living_situation: "",

        },
        presenting_complaints_formData: {
          main_issue: "",
          duration: "",
          severity: "",
          triggers: [],
        },
        presenting_factors_formData: {
          immediate_symptoms: "",
          stressors: [],
        },
        past_treatment_history: {
          previous_diagnosis: "",
          treatment: "",
          response_to_treatment: "",

        },
        family_history: {
          family_history_of_mental_health_issues: "",
          type_of_conditions: "",
          genogram: "",
        },
        developmental_history: {
          birth_history: "",
          early_milestone: {
            sitting_up: "",
            speech_development: "",
          },
          social_development: {
            early_friendships: "",
            group_activities_participation: "",
          },
          academic_performance: {
            early_schooling_experience: "",
            grades_and_subjects: "",
          },
          family_dynamics: {
            relationship_with_parents_siblings: "",
            significant_family_events: "",

          },
          behavioral_issues: {
            reported_problems_in_childhood: "",
            invervention_or_assessments: "",
          },

        },
        premorbid_history: {

          personality_traits: "",
          social_relationship: "",
          functioning_in_daily_life: "",
        },
        preciptating_history: {
          recent_life_events: [],
          changes_in_routine: "",
        },
        perpetuating_factors: {
          ongoing_stressors: [],
          behavioural_pattern_maintaining_symptoms: "",
          lack_of_support_system: "",
        },
        prognostic_factors: {
          severity_and_duration_of_symptoms: "",
          response_to_previous_treatments: "",
          support_systems_available: "",
          comorbid_conditions: "",

        },
        mental_status_examination: {
          appearence: "",
          behavior: "",
          speech: "",
          mood: "",
          thought_process: "",
          thought_content: "",
          perception: "",
          cognition_orientation: "",
          insight: "",

        },
        case_formulation: "",
      },


      socio_demographic_error: {
        education_level: "",
        occupation: "",
        living_situation: "",
      },
      presenting_complaints_error: {
        main_issue: "",
        duration: "",
        severity: "",
        triggers: [],
      },
      presenting_factors_error: {
        immediate_symptoms: "",
        stressors: [],
      },
      past_treatment_history_error: {
        previous_diagnosis: "",
        treatment: "",
        response_to_treatment: "",

      },
    }

    this.socio_demographic_columns = [
      {
        key: "id",
        text: "S.No",
        className: "s_no",
        align: "left",
        sortable: true,
      },
      {
        key: "education_level",
        text: "Education Level",
        className: "education_level",
        align: "left",
        sortable: true,
      },
      {
        key: "occupation",
        text: "Occupation",
        className: "occupation",
        sortable: true,
        align: "left",
      },
      {
        key: "living_situation",
        text: "Living Situation",
        className: "living_situation",
        sortable: true,
        align: "left",

      },
      {
        key: "action",
        text: "Action",
        show: false,
        width: 100,
        align: "left",
        className: "hideAction",
        TrOnlyClassName: "hideAction",
        sortable: true,
        cell: (record) => {
          return (
            <Fragment>
              <button
                type="button"
                className="btn btn-blue btn-sm btn-space"
                onClick={() => {
                  this.setState({ medEdit: true, medAction: "edit" });
                  this.editMedicalRecord(record);
                }}
              >
                <i className="fa fa-edit"></i>
              </button>
              <button
                type="button"
                className="btn btn-danger btn-sm btn-space"
                onClick={() => this.onDeleteClick(record, "socioDemographic")}
              >
                <i className="fa fa-trash"></i>
              </button>
            </Fragment>
          );
        },
      },
    ];
  }
  onDeleteClick(record, tableName) {
    this.setState({ addPopup: true, record: record, tableName: tableName });
  }

  deleteRecord(record, tableName) {
    if ("education" === tableName) {
      let records = this.state.businessUserData.educational_qualification;
      const deleteIndex = records.map((item) => item.id).indexOf(record.id);
      records.splice(deleteIndex, 1);
      toast.success("Education deleted.Please save the changes. ", {
        className: "toast-success"
      });
    } else if ("certificate" === tableName) {
      let records = this.state.businessUserData.certification;
      const deleteIndex = records.map((item) => item.id).indexOf(record.id);
      records.splice(deleteIndex, 1);
      toast.success("Certificate deleted.Please save the changes. ", {
        className: "toast-success"
      });
    } else if ("experience" === tableName) {
      let records = this.state.businessUserData.experience;
      const deleteIndex = records.map((item) => item.id).indexOf(record.id);
      records.splice(deleteIndex, 1);
      toast.success("Experience deleted.Please save the changes. ", {
        className: "toast-success"
      });
    } else if ("socioDemographic" === tableName) {
      let records = this.state.socio_demographic_details;
      const deleteIndex = records.map((item) => item.id).indexOf(record.id);
      records.splice(deleteIndex, 1);
      toast.success("Socio Demographic deleted.Please save the changes. ", {
        className: "toast-success"
      });
    }
    this.setState({ addPopup: false, record: "" });
  }
  componentDidMount() {


    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    console.log(this.props.id)
    const checkinData = { id: this.props.id };

    axios
      .post(getCheckinDetails, checkinData, CONFIG)
      .then((res) => {
        let data = res.data.data || res.data.date;
        if (res.data.status !== "1" || !data) {
          return;
        }


        console.log(res.data.status)
        this.setState({
          checkindetails: res.data.data,
          client_id: this.state.checkindetails.client_id,
          business_id: this.state.checkindetails.business_id,
          business_user_id: this.state.checkindetails.business_user_id,

        });
        console.log(this.state.checkindetails);
        console.log(this.state.checkindetails.client_id);



      }).catch((e) => { });

    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    axios
      .get(getAllBusinessList, null, CONFIG)
      .then((list) => {
        console.log(list)
        let business = [];
        let userlist = list.data.data;
        userlist.forEach((element, index) => {
          business.push({ label: element.business_name, value: element.user_id })
        });

        this.setState({ business_list: business });
      })
      .catch((e) => { console.log(e) });
  }
  clearMessage = () => {
    setTimeout(
      () =>
        this.setState({
          successMessage: "",
          errorMessage: "",

        }),
      5000
    );
  };

  handleInput = (e) => {
    let data = this.state.followupData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    console.log(max);

    if (
      name === "follow_up_details" || name === "consultation_fee") {



      this.validateMaxLength(name, value, max);
    }

    else {
      data[name] = value;
    }
    this.setState({ followupData: data });

  }

  closePopup = (e) => {
    this.setState({
      openModal: false, errors: {}, error: "", successMessage: "", errorMessage: "",
      listofClientForQueue: []
    });
  };

  handleselectDocChange = (selectedOptions, e) => {
    let data = this.state.selected_doc;
    data = selectedOptions;

    this.setState({ selected_doc: data });

    console.log(this.state.doctor_appointment_detail_list);

    let appointmentDetails = this.state.doctor_appointment_detail_list;

    let selected_appointment = this.state
      .selected_doctor_appointment_detail_list;

    let selected_doc_schedule_type = this.state.selected_doc_schedule_type;

    appointmentDetails.forEach((element, index) => {
      console.log(element.business_user_id);
      console.log(element.doctor_Appointments);
      if (element.business_user_id == selectedOptions.value) {
        console.log("true");
        selected_appointment = element.doctor_Appointments;
        selected_doc_schedule_type = element.schedule_type;
      } else {
        console.log("false");
      }
    });
    this.setState({
      selected_doctor_appointment_detail_list: selected_appointment,
      selected_doc_schedule_type: selected_doc_schedule_type
    });
  };

  handleselectChange = (selectedOptions, e) => {
    let data = this.state.searchData;
    let errors = this.state.errors;
    // console.log(e.name);
    data[e.name] = selectedOptions;

    // if (e.name === "business_name" && null != selectedOptions) {
    //   console.log(selectedOptions);
    //   data.latitude = selectedOptions.latitude;
    //   data.longitude = selectedOptions.longitude;
    // } else {
    //   data.latitude = this.state.latitude;
    //   data.longitude = this.state.longitude;
    // }
    this.setState({ searchData: data, errors, speciality_error: "" });


  };
  handleQueueInput = (e) => {
    let data = this.state.queuein_data;
    let name = e.target.name;
    let value = e.target.value;
    data[name] = value;
    this.setState({ queuein_data: data });
  }
  createNotification = () => {
    let { queuein_data, selected_doc, checkindetails } = this.state;
    console.log(queuein_data);
    console.log(checkindetails);
    let message = "<p>Hi " + checkindetails.first_name + " " + checkindetails.last_name + ",</p>" + "Thank you for visiting " + selected_doc.label + " referred you for an appointment at " + queuein_data.business_name + " hospital for checkups.<p> Please arrive 10 minutes prior to your appointment time.Thank you.</p><p>Sincerely,</p><p>KlinicQ Team.</p>";
    //return false;

    let notification_message = "Hi " + checkindetails.first_name + " " + checkindetails.last_name + "," + " Thank you for visiting " + selected_doc.label + " referred you for an appointment at " + queuein_data.business_name + " hospital for checkups. Please arrive 10 minutes prior to your appointment time.Thank you.Sincerely,KlinicQ Team.";

    let notificationdata = {
      message_from: selected_doc.value,
      message_to: checkindetails.client_id,
      message: notification_message,
      link: "",

    }


    let reqdata = {
      "to": checkindetails.email,
      "subject": "Referral Doctor",
      "mailHeader": "Referral Doctor",
      "message": message
    }
    let notificationdata1 = {
      "message_code": "REFERRAL_DOCTOR",
      "language_code": "en",
      "data": {
        "doctor_name": selected_doc.label,
        "business_name": queuein_data.business_name

      },
      "receiver": {
        "phoneNumber": checkindetails.phone_code.concat(checkindetails.phone_number)
      }
    };


    this.setState({ loading: true }, () => {
      axios.post(createNotification, notificationdata).then((res) => {



        axios
          .post(sendemail, reqdata)
          .then((res) => {
            let resdata = res.data;
            console.log(res);
            axios
              .post(sendsms, notificationdata1)
              .then((response) => { console.log(response) }).catch((err) => {
                console.log(err);
              })
            /*   toast.success("Referral doctor successfully.", {
                className: "toast-success",
                }); */
            this.setState({ successMessage: "The Referral mail has been sent successfully.", loading: false });
            this.clearMessage();
          })
          .catch((e) => { console.log(e) });



        this.closePopup();
        // console.log(this.state.queuein_data); return false;
        // this.props.history.push("/scheduleconfirmation/" + qid);

        // window.location.replace("/scheduleconfirmation/" + qId);
      }).catch((e) => {

      });
    });






  }
  clear = () => {
    let search = { business_name: "", speciality: "" };
    let searchresults = {
      data: [],
    };
    this.setState({ searchresults: searchresults, searchData: search, speciality_error: "", errorMessage: "" });

  }
  render() {
    let PopupClose = () => this.setState({ addPopup: false });
    let PopupConfirm = () =>
      this.deleteRecord(this.state.record, this.state.tableName);
    let specialities_array = this.props.appdata
      ? this.props.appdata[0].specialities
      : [];
    let specialities = [];
    specialities_array.forEach((element, index) => {
      specialities.push({ value: element.id, label: element.name });
    });
    specialities_array = specialities;
    const {
      business_list, searchData, searchresults, selected_doc, doctor_list, caseHistory, loading, successMessage,
      errorMessage, socio_demographic_formData, presenting_complaints_formData,
      socio_demographic_error, presenting_complaints_error, presenting_factors_formData, presenting_factors_error
    } = this.state;
    return (
      <>
        <div className="col-sm-12 pr0">


          {loading && <Dnaspinner />}

          <ToastContainer position="bottom-center" hideProgressBar={true} autoClose={2000} closeOnClick={false} pauseOnHover />

          <div className="card">
            <div className="user-notification">
              <SpanField
                classname="text-success mt-2"
                title={successMessage}
              />
              <SpanField
                classname="text-danger mt-2"
                title={errorMessage}
              />
              <Popup
                show={this.state.addPopup}
                onHide={PopupClose}
                onConfirm={PopupConfirm}
                title={"Confirmation"}
                message={
                  "Are you sure you want to delete this record ?"
                }
              />
            </div>
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>1.Socio Demographic Data</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? (
                      <div
                        className={
                          this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                            ? "show-reactData-table w-100"
                            : "hide-reactData-table col-sm-12"
                        }
                      >
                        <ReactDatatable
                          className="table table-bordered table-striped kas  mobile_table"
                          config={this.config}
                          records={
                            this.state.socio_demographic_details
                          }
                          columns={this.socio_demographic_columns}
                          id="Medical_datatable"

                        />
                      </div>
                    ) : ""}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Education Level" className="label" isMandatory={true} />
                            </div>

                            <div className="form-group ">
                              <CheckboxOrRadioGroup
                                setName={"education_level"}
                                type={"radio"}
                                controlFunc={this.handleEducationLevel}
                                options={education_level}
                                selectedOptions={[caseHistory.socio_demographic_formData?.education_level]}
                              />

                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                socio_demographic_error.education_level
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          {/* <div className="col-sm-3"> */}
                          <div className="frllftfull">
                            <div className="form-group  frllft">
                              <Label title="Occupation" className="label" isMandatory={true} />
                            </div>
                            <div className=" frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"occupation"}
                                  type={"radio"}
                                  controlFunc={this.handleOccupation}
                                  options={occupation}
                                  selectedOptions={[caseHistory.socio_demographic_formData?.occupation]}
                                />

                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  socio_demographic_error.occupation
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Living Situation" className="label" isMandatory={true} />
                              </div>
                              <TextArea
                                className="textareacontainer"
                                rows={4}
                                resize={true}
                                content={this.state.caseHistory.socio_demographic_formData.living_situation || ""}
                                name="living_situation"
                                controlFunc={this.handleSocioDemographicInputChange}
                                placeholder="Describe your living situation"
                                maxLength={200}
                              />


                              <SpanField
                                classname="text-danger"
                                title={
                                  socio_demographic_error.living_situation
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/*   <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>


                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>


          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>2.Presenting Complaints</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Main Issue" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.presenting_complaints_formData.main_issue || ""}
                                  name="main_issue"
                                  controlFunc={this.handlePresentingcomplaintsmainissueInputChange}
                                  placeholder="Describe the main issue"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_complaints_error.main_issue
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          {/* <div className="col-sm-3"> */}
                          <div className="frllftfull">
                            <div className="form-group  frllft">
                              <Label title="Duration" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <InputField
                                  inputType={"text"}
                                  name={"duration"}
                                  controlFunc={this.handlePresentingcomplaintsInputChange}
                                  value={caseHistory.presenting_complaints_formData.duration}
                                  placeholder={""}
                                  isvisible={false}
                                  max={20}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_complaints_error.duration
                              }
                            />

                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Severity" className="label" />
                              </div>

                              <CheckboxOrRadioGroup
                                setName={"severity"}
                                type={"radio"}
                                controlFunc={this.handleSeverity}
                                options={severity}
                                selectedOptions={[caseHistory.presenting_complaints_formData.severity]}
                              />

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_complaints_error.severity
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Triggers" className="label" />
                              </div>
                              <CheckboxOrRadioGroup
                                setName={"triggers"}
                                type={"checkbox"}
                                controlFunc={this.handleTriggers}
                                options={triggers}
                                selectedOptions={caseHistory.presenting_complaints_formData.triggers}

                              />


                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_complaints_error.triggers
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/*   <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>3.Presenting Factors</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Immediate Symptoms" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.presenting_factors_formData.immediate_symptoms || ""}
                                  name="immediate_symptoms"
                                  controlFunc={this.handlePresentingfactorsInputChange}
                                  placeholder="Describe the main issue"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Stressors" className="label" />
                              </div>
                              <CheckboxOrRadioGroup
                                setName={"stressors"}
                                type={"checkbox"}
                                controlFunc={this.handleStressors}
                                options={stressors}
                                selectedOptions={caseHistory.presenting_factors_formData.stressors}
                              // checked={this.state.presenting_complaints_formData.triggers.includes(triggers)}
                              />


                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>4.Past Treatment History</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Previous Diagnosis" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.past_treatment_history.previous_diagnosis || ""}
                                  name="previous_diagnosis"
                                  controlFunc={this.handlePastTreatmentHistoryInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.previous_diagnosis
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Treatment/Medication" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.past_treatment_history.treatment || ""}
                                  name="treatment"
                                  controlFunc={this.handlePastTreatmentHistoryInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Response to treatment" className="label" />
                              </div>
                              <CheckboxOrRadioGroup
                                setName={"response_to_treatment"}
                                type={"radio"}
                                controlFunc={this.handleResponsetoTreatment}
                                options={responsetotreatment}
                                selectedOptions={[caseHistory.past_treatment_history?.response_to_treatment]}
                              />

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>5.Family History</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Family History of Mental Health issues?" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"family_history_of_mental_health_issues"}
                                  type={"radio"}
                                  controlFunc={this.handleFamilyHistoryofMentalheathIssues}
                                  options={family_history}
                                  selectedOptions={[caseHistory.family_history.family_history_of_mental_health_issues]}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Type of Conditions" className="label" />
                              </div>
                              <CheckboxOrRadioGroup
                                setName={"type_of_conditions"}
                                type={"radio"}
                                controlFunc={this.handleTypeofConditions}
                                options={type_of_conditions}
                                selectedOptions={caseHistory.family_history.type_of_conditions}
                              />

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.type_of_conditions
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Genogram" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.family_history.genogram || ""}
                                  name="genogram"
                                  controlFunc={this.handleGenogram}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>


                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>6.Developmental History</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="a. Birth History(Prenatal Factor/Birth Complictions)" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.birth_history || ""}
                                  name="birth_history"
                                  controlFunc={this.handleDevelopmentalHistoryInput}
                                  placeholder="Describe here"
                                  maxLength={200}

                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="b. Early Milestone" className="label" />
                            </div>
                            <div className="form-group frllft">

                            </div>
                            <div className="frlrit">
                              <div className="form-group ">


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Sitting Up" className="label" />
                              </div>
                              <CheckboxOrRadioGroup
                                setName={"sitting_up"}
                                type={"radio"}
                                controlFunc={this.handleHandleSittingUp}
                                options={sitting_up}
                                selectedOptions={[caseHistory.developmental_history.early_milestone.sitting_up]}
                              />

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Speech Development" className="label" />
                              </div>
                              <CheckboxOrRadioGroup
                                setName={"speech_development"}
                                type={"radio"}
                                controlFunc={this.handleHandleSpeechDevelopment}
                                options={speech_development}
                                selectedOptions={[caseHistory.developmental_history.early_milestone.speech_development]}
                              />

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="c. Social Development" className="label" />
                              </div>

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="i. Early Friendships & interaction" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.social_development.early_friendships || ""}
                                  name="early_friendships"
                                  controlFunc={this.handleDevelopmentalHistorySocialDevelopmentInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="ii. Group activities participation" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.social_development.group_activities_participation || ""}
                                  name="group_activities_participation"
                                  controlFunc={this.handleDevelopmentalHistorySocialDevelopmentInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="d. Academic Performance" className="label" />
                              </div>

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="i. Early Schooling Experience" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.academic_performance.early_schooling_experience || ""}
                                  name="early_schooling_experience"
                                  controlFunc={this.handleDevelopmentalHistoryAcademicPerformanceInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="ii. Grades & Subjects" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.academic_performance.grades_and_subjects || ""}
                                  name="grades_and_subjects"
                                  controlFunc={this.handleDevelopmentalHistoryAcademicPerformanceInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="e. Family Dynamics" className="label" />
                              </div>

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="i. Relationship with Parents & Siblings" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.family_dynamics.relationship_with_parents_siblings || ""}
                                  name="relationship_with_parents_siblings"
                                  controlFunc={this.handleDevelopmentalHistoryFamilyDynamicsInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="ii. Significant Family Events" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.family_dynamics.significant_family_events || ""}
                                  name="significant_family_events"
                                  controlFunc={this.handleDevelopmentalHistoryFamilyDynamicsInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="f. Behavioural Issues" className="label" />
                              </div>

                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="i. Reported problems in childhood" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.behavioral_issues.reported_problems_in_childhood || ""}
                                  name="reported_problems_in_childhood"
                                  controlFunc={this.handleDevelopmentalHistoryBehaviouralIssuesInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="ii. Intervention or Assessments" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.developmental_history.behavioral_issues.invervention_or_assessments || ""}
                                  name="invervention_or_assessments"
                                  controlFunc={this.handleDevelopmentalHistoryBehaviouralIssuesInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.invervention_or_assessments
                              }
                            />
                          </div>

                        </div>
                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>7.Premorbid History</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Personality Traits" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"personality_traits"}
                                  type={"radio"}
                                  controlFunc={this.handlePersonalityTraits}
                                  options={personality_traits}
                                  selectedOptions={[caseHistory.premorbid_history.personality_traits]}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Social Relationship" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.premorbid_history.social_relationship || ""}
                                    name="social_relationship"
                                    controlFunc={this.handlePremorbidHistoryInput}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Functioning in Daily Life" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.premorbid_history.functioning_in_daily_life || ""}
                                  name="functioning_in_daily_life"
                                  controlFunc={this.handlePremorbidHistoryInput}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>


                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>8.Preciptating History</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Recent life events/Stressors" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"recent_life_events"}
                                  type={"radio"}
                                  controlFunc={this.handleRecentLifeEvents}
                                  options={recent_life_events}
                                  selectedOptions={caseHistory.preciptating_history.recent_life_events}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Changes in routine or environment" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.preciptating_history.changes_in_routine || ""}
                                    name="changes_in_routine"
                                    controlFunc={this.handlePreciptatingHistoryInputChange}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>



                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>9.Perpetuating Factors</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Ongoing Stressors" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"ongoing_stressors"}
                                  type={"radio"}
                                  controlFunc={this.handleOngoingStressors}
                                  options={ongoing_stressors}
                                  selectedOptions={[caseHistory.perpetuating_factors.ongoing_stressors]}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="Behavioural Patterns Maintaining Symptoms" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.perpetuating_factors.behavioural_pattern_maintaining_symptoms || ""}
                                    name="behavioural_pattern_maintaining_symptoms"
                                    controlFunc={this.handlePerpetuatingFactorsInputChange}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="Lack of Support System" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.perpetuating_factors.lack_of_support_system || ""}
                                  name="lack_of_support_system"
                                  controlFunc={this.handlePerpetuatingFactorsInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>


                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>10.Prognostic Factors</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>


                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="a. Severity & Duration of Symptoms" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.prognostic_factors.severity_and_duration_of_symptoms || ""}
                                    name="severity_and_duration_of_symptoms"
                                    controlFunc={this.handlePrognosticFactorsInputChange}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="b. Response to Previous Treatments" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.prognostic_factors.response_to_previous_treatments || ""}
                                  name="response_to_previous_treatments"
                                  controlFunc={this.handlePrognosticFactorsInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="c. Support Systems Available" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.prognostic_factors.support_systems_available || ""}
                                    name="support_systems_available"
                                    controlFunc={this.handlePrognosticFactorsInputChange}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="d. Comorbid Conditions" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.prognostic_factors.comorbid_conditions || ""}
                                  name="comorbid_conditions"
                                  controlFunc={this.handlePrognosticFactorsInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>


                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>11.Mental Status Examination</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>


                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="a. Appearence(Grooming/Attire/Hygiene)" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.mental_status_examination.appearence || ""}
                                    name="appearence"
                                    controlFunc={this.handleMentalStatusExaminationInputChange}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="b. Behaviour(Eye-Contact/Movement/Cooperation)" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.mental_status_examination.behavior || ""}
                                  name="behavior"
                                  controlFunc={this.handleMentalStatusExaminationInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="c. Speech" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"speech"}
                                  type={"radio"}
                                  controlFunc={this.handleSpeech}
                                  options={speech}
                                  selectedOptions={[caseHistory.mental_status_examination.speech]}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">
                              <div className="form-group  frllft">
                                <Label title="d. Mood/Affect(Reported mood & observed affect)" className="label" />
                              </div>
                              <div className="frlrit">
                                <div className="form-group ">

                                  <TextArea
                                    className="textareacontainer"
                                    rows={4}
                                    resize={true}
                                    content={this.state.caseHistory.mental_status_examination.mood || ""}
                                    name="mood"
                                    controlFunc={this.handleMentalStatusExaminationInputChange}
                                    placeholder="Describe here"
                                    maxLength={200}
                                  />
                                </div>
                              </div>
                              <SpanField
                                classname="text-danger"
                                title={
                                  presenting_factors_error.stressors
                                }
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="e. Thought Process" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"thought_process"}
                                  type={"radio"}
                                  controlFunc={this.handleThoughtProcess}
                                  options={thought_process}
                                  selectedOptions={[caseHistory.mental_status_examination.thought_process]}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="f.Thought Content(Presence of delusions,obsessions,preoccupations)" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.mental_status_examination.thought_content || ""}
                                  name="thought_content"
                                  controlFunc={this.handleMentalStatusExaminationInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>

                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="g. perception(Hallucination,Perceptual disturbances)" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.mental_status_examination.perception || ""}
                                  name="perception"
                                  controlFunc={this.handleMentalStatusExaminationInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="h. Cognition Orientation   (time,place,person,attention,Memory)" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <TextArea
                                  className="textareacontainer"
                                  rows={4}
                                  resize={true}
                                  content={this.state.caseHistory.mental_status_examination.cognition_orientation || ""}
                                  name="cognition_orientation"
                                  controlFunc={this.handleMentalStatusExaminationInputChange}
                                  placeholder="Describe here"
                                  maxLength={200}
                                />


                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group frllft">
                              <Label title="i.Insight/Judgement:Awareness of illness,decision making ability" className="label" />
                            </div>
                            <div className="frlrit">
                              <div className="form-group ">
                                <CheckboxOrRadioGroup
                                  setName={"insight"}
                                  type={"radio"}
                                  controlFunc={this.handleInsight}
                                  options={insight}
                                  selectedOptions={[caseHistory.mental_status_examination.insight]}
                                />

                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.immediate_symptoms
                              }
                            />
                          </div>

                        </div>
                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
          <div className="card">
            <div className="card-body">
              <div className="tab-content  pd-15" id="v-pills-tabContent">
                <div className="tab-pane fade show active" id="v-pills-shipping" role="tabpanel" aria-labelledby="v-pills-shipping-tab">

                  <div className="col-sm-12">
                    <h5 className=" mt-0 mb-15">
                      <b>12.Case Formulation</b>
                      <button
                        style={{
                          display: this.state.isDisable
                            ? "none"
                            : "",
                        }}
                        type="button"
                        className="btn btn-blue btn-sm btn-space"
                        onClick={() => {
                          this.setState({
                            medEdit: true,
                          });
                        }}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </h5>
                    {/* {this.state.socio_demographic_details && this.state.socio_demographic_details.length ? ( 
                                              <div
                                                className={
                                                  this.state.socio_demographic_details && this.state.socio_demographic_details.length > 0
                                                    ? "show-reactData-table w-100"
                                                    : "hide-reactData-table col-sm-12"
                                                }
                                              >
                                                <ReactDatatable
                                                className="table table-bordered table-striped kas  mobile_table"
                                                  config={this.config}
                                                  records={
                                                    this.state.socio_demographic_details
                                                  }
                                                  columns={this.socio_demographic_columns}
                                                  id="Medical_datatable"
                                                  
                                                />
                                              </div>
                                          ):""}  */}
                    <div
                      className="row nomargin"
                      style={{
                        display: this.state.medEdit
                          ? "flex"
                          : "none",
                      }}
                    >
                      <Fragment>


                        <div className="col-md-12">
                          <div className="frllftfull">
                            <div className="form-group">


                              <div className="form-group ">

                                <TextArea
                                  className="textareacontainer"
                                  rows={7}
                                  resize={true}
                                  content={this.state.caseHistory.case_formulation || ""}
                                  name="case_formulation"
                                  controlFunc={this.handleCaseFormulationInputChange}
                                  placeholder="Describe here"
                                  maxLength={2000}
                                />
                              </div>
                            </div>
                            <SpanField
                              classname="text-danger"
                              title={
                                presenting_factors_error.stressors
                              }
                            />
                          </div>

                        </div>



                        <div className="col-sm-3">
                          <label></label>
                          <div className="row">
                            {/* <button
                              type="button"
                              onClick={this.addSocioDemographicDetail.bind(this)}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className={
                                  "edit" ===
                                    this.state.medAction
                                    ? "fa fa-edit"
                                    : "fa fa-plus"
                                }
                                aria-hidden="true"
                              ></i>
                            </button> */}
                            <button
                              type="button"
                              onClick={this.cancelAddEdit.bind(
                                this,
                                "medicalLicence"
                              )}
                              className="plusbtn-lft plusbtn-position"
                            >
                              <i
                                className="fa fa fa-ban"
                                aria-hidden="true"
                              ></i>
                            </button>

                          </div>
                        </div>
                      </Fragment>
                    </div>
                  </div>

                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="">

          <div className="text-center mt-2 mr-2 float-right"><button onClick={() =>
            this.submitCaseHistory()
          } className=" signupbtn  pad-6 margin-10" >Next</button>
          </div>
        </div>

      </>

    );
  }
  handleEducationLevel = (e) => {
    let data = this.state.caseHistory.socio_demographic_formData;
    data.education_level = e.target.value;
    this.setState({ socio_demographic_formData: data });
  };
  handleSpeech = (e) => {
    let data = this.state.caseHistory.mental_status_examination;
    data.speech = e.target.value;
    this.setState({ mental_status_examination: data });
  };
  handleThoughtProcess = (e) => {
    let data = this.state.caseHistory.mental_status_examination;
    data.thought_process = e.target.value;
    this.setState({ mental_status_examination: data });
  };
  handleInsight = (e) => {
    let data = this.state.caseHistory.mental_status_examination;
    data.insight = e.target.value;
    this.setState({ mental_status_examination: data });
  };
  handleOccupation = (e) => {
    let data = this.state.caseHistory.socio_demographic_formData;
    data.occupation = e.target.value;
    this.setState({ socio_demographic_formData: data });
  };
  handleOngoingStressors = (e) => {
    let data = this.state.caseHistory.perpetuating_factors;
    data.ongoing_stressors = e.target.value;
    this.setState({ perpetuating_factors: data });
  };
  handleHandleSittingUp = (e) => {
    let data = this.state.caseHistory.developmental_history.early_milestone;
    data.sitting_up = e.target.value;
    this.setState({ early_milestone: data });
  };
  handleHandleSpeechDevelopment = (e) => {
    let data = this.state.caseHistory.developmental_history.early_milestone;
    data.speech_development = e.target.value;
    this.setState({ early_milestone: data });
  };
  handleTriggers = (e) => {
    const { value, checked } = e.target;
    const { triggers } = this.state.caseHistory.presenting_complaints_formData;

    if (checked) {
      // Add the trigger if checked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          presenting_complaints_formData: {
            ...prevState.caseHistory.presenting_complaints_formData,
            triggers: [...triggers, value]
          }
        }
      }));

      if (value == "others") {
        console.log("others");
      }
    } else {
      // Remove the trigger if unchecked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          presenting_complaints_formData: {
            ...prevState.caseHistory.presenting_complaints_formData,
            triggers: checked
              ? [...triggers, value]
              : triggers.filter(trigger => trigger !== value)
          }
        }
      }));

    }
  };
  handleStressors = (e) => {
    const { value, checked } = e.target;
    const { stressors } = this.state.caseHistory.presenting_factors_formData;

    if (checked) {
      // Add the stressor if checked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          presenting_factors_formData: {
            ...prevState.presenting_factors_formData,
            stressors: [...stressors, value]
          }
        }
      }));

      if (value == "others") {
        console.log("others");
      }
    } else {
      // Remove the stressor if unchecked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          presenting_factors_formData: {
            ...prevState.presenting_factors_formData,
            stressors: stressors.filter(stressor => stressor !== value)
          }
        }
      }));
    }
  };
  handleRecentLifeEvents = (e) => {
    const { value, checked } = e.target;
    const { recent_life_events } = this.state.caseHistory.preciptating_history;

    if (checked) {
      // Add the trigger if checked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          preciptating_history: {
            ...prevState.caseHistory.preciptating_history,
            recent_life_events: [...recent_life_events, value]
          }
        }
      }));

      if (value == "others") {
        console.log("others");
      }
    } else {
      // Remove the trigger if unchecked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          preciptating_history: {
            ...prevState.caseHistory.preciptating_history,
            recent_life_events: checked
              ? [...recent_life_events, value]
              : recent_life_events.filter(recent => recent !== value)
          }
        }
      }));

    }
  };

  handleResponsetoTreatment = (e) => {
    let data = this.state.caseHistory.past_treatment_history;
    data.response_to_treatment = e.target.value;
    this.setState({ past_treatment_history: data });
  };
  handleFamilyHistoryofMentalheathIssues = (e) => {
    let data = this.state.caseHistory.family_history;
    data.family_history_of_mental_health_issues = e.target.value;
    this.setState({ family_history: data });
  };
  handleTypeofConditions = (e) => {
    const { value, checked } = e.target;
    const { type_of_conditions } = this.state.caseHistory.family_history;

    if (checked) {
      // Add the stressor if checked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          family_history: {
            ...prevState.family_history,
            type_of_conditions: [...type_of_conditions, value]
          }
        }
      }));

      if (value == "others") {
        console.log("others");
      }
    } else {
      // Remove the stressor if unchecked
      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          family_history: {
            ...prevState.family_history,
            type_of_conditions: type_of_conditions.filter(type => type !== value)
          }
        }
      }));
    }
  };


  handleSeverity = (e) => {
    let data = this.state.caseHistory.presenting_complaints_formData;
    data.severity = e.target.value;
    this.setState({ presenting_complaints_formData: data });
  };
  handleInputChange = (e) => {
    let data = this.state.caseHistory.socio_demographic_formData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "living_situation"


    ) {
      this.validateMaxLength(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ socio_demographic_formData: data });
  };
  handlePresentingcomplaintsmainissueInputChange = (e) => {
    let data = this.state.caseHistory.presenting_complaints_formData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "main_issue"


    ) {
      this.validateMaxLengthpresentingcomplaints(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ presenting_complaints_formData: data });
  };

  handlePresentingcomplaintsInputChange = (e) => {
    const { name, value, max } = e.target;

    // Create a shallow copy of the current form data

    if (name === "duration") {
      // Perform validation if necessary
      this.validateMaxLengthpresentingcomplaints(name, value, max);
    } else {

      this.setState(prevState => ({
        caseHistory: {
          ...prevState.caseHistory,
          presenting_complaints_formData: {
            ...prevState.caseHistory.presenting_complaints_formData,
            [name]: value
          }
        }
      }));

    }



  };
  handlePerpetuatingFactorsInputChange = (e) => {
    let data = this.state.caseHistory.perpetuating_factors;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "behavioural_pattern_maintaining_symptoms" || name === "lack_of_support_system"


    ) {
      this.validateMaxLengthPerpetuatingFactors(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ perpetuating_factors: data });
  };
  validateMaxLengthPerpetuatingFactors(name, value, max) {
    let data = this.state.caseHistory.perpetuating_factors;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ perpetuating_factors: data, errors: errors });
  }
  handlePreciptatingHistoryInputChange = (e) => {
    let data = this.state.caseHistory.preciptating_history;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "changes_in_routine"


    ) {
      this.validateMaxLengthPresciptatingHistory(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ preciptating_history: data });
  };
  validateMaxLengthPresciptatingHistory(name, value, max) {
    let data = this.state.caseHistory.preciptating_history;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ preciptating_history: data, errors: errors });
  }
  handlePresentingfactorsInputChange = (e) => {
    let data = this.state.caseHistory.presenting_factors_formData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "immediate_symptoms"


    ) {
      this.validateMaxLengthpresentingfactors(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ presenting_factors_formData: data });
  };
  handleCaseFormulationInputChange = (e) => {
    let data = this.state.caseHistory;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "case_formulation"


    ) {
      this.validateMaxLengthcaseformulation(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ caseHistory: data });
  };
  validateMaxLengthcaseformulation(name, value, max) {
    let data = this.state.caseHistory;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ caseHistory: data, errors: errors });
  }
  handleDevelopmentalHistoryInput = (e) => {
    let data = this.state.caseHistory.developmental_history;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "birth_history"


    ) {
      this.validateMaxLengthdevelopmentalhistory(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ developmental_history: data });
  };
  validateMaxLengthdevelopmentalhistory(name, value, max) {
    let data = this.state.caseHistory.developmental_history;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ developmental_history: data, errors: errors });
  }
  handlePremorbidHistoryInput = (e) => {
    let data = this.state.caseHistory.premorbid_history;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "social_relationship" || name === "functioning_in_daily_life"


    ) {
      this.validateMaxLengthPremorbidHistory(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ premorbid_history: data });
  };
  validateMaxLengthPremorbidHistory(name, value, max) {
    let data = this.state.caseHistory.premorbid_history;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      data[name] = value;
    }
    this.setState({ premorbid_history: data, errors: errors });
  }
  handleDevelopmentalHistorySocialDevelopmentInput = (e) => {
    let data = this.state.caseHistory.developmental_history.social_development;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "early_friendships" || name === "group_activities_participation"


    ) {
      this.validateMaxLengthdevelopmentalhistorySocialDevelopment(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ social_development: data });
  };
  validateMaxLengthdevelopmentalhistorySocialDevelopment(name, value, max) {
    let data = this.state.caseHistory.developmental_history.social_development;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      data[name] = value;
    }
    this.setState({ social_development: data, errors: errors });
  }

  handleDevelopmentalHistoryAcademicPerformanceInput = (e) => {
    let data = this.state.caseHistory.developmental_history.academic_performance;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "early_schooling_experience" || name === "grades_and_subjects"


    ) {
      this.validateMaxLengthdevelopmentalhistoryAcademicPerformance(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ academic_performance: data });
  };
  validateMaxLengthdevelopmentalhistoryAcademicPerformance(name, value, max) {
    let data = this.state.caseHistory.developmental_history.academic_performance;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      data[name] = value;
    }
    this.setState({ academic_performance: data, errors: errors });
  }
  handleDevelopmentalHistoryFamilyDynamicsInput = (e) => {
    let data = this.state.caseHistory.developmental_history.family_dynamics;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "relationship_with_parents_siblings" || name === "significant_family_events"


    ) {
      this.validateMaxLengthdevelopmentalhistoryFamilyDynamics(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ family_dynamics: data });
  };
  validateMaxLengthdevelopmentalhistoryFamilyDynamics(name, value, max) {
    let data = this.state.caseHistory.developmental_history.family_dynamics;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      data[name] = value;
    }
    this.setState({ family_dynamics: data, errors: errors });
  }

  handleDevelopmentalHistoryBehaviouralIssuesInput = (e) => {
    let data = this.state.caseHistory.developmental_history.behavioral_issues;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "reported_problems_in_childhood" || name === "invervention_or_assessments"


    ) {
      this.validateMaxLengthdevelopmentalhistoryBehaviouralIssues(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ behavioral_issues: data });
  };
  validateMaxLengthdevelopmentalhistoryBehaviouralIssues(name, value, max) {
    let data = this.state.caseHistory.developmental_history.behavioral_issues;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      data[name] = value;
    }
    this.setState({ behavioral_issues: data, errors: errors });
  }
  handleGenogram = (e) => {
    let data = this.state.caseHistory.family_history;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "genogram"


    ) {
      this.validateMaxLengthGenogram(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ family_history: data });
  };
  validateMaxLengthGenogram(name, value, max) {
    let data = this.state.caseHistory.family_history;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ family_history: data, errors: errors });
  }
  handlePastTreatmentHistoryInputChange = (e) => {
    let data = this.state.caseHistory.past_treatment_history;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "previous_diagnosis" || name === "treatment"


    ) {
      this.validateMaxLengthPastTreatmentHistory(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ presenting_factors_formData: data });
  };
  validateMaxLengthPastTreatmentHistory(name, value, max) {
    let data = this.state.caseHistory.past_treatment_history;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ past_treatment_history: data, errors: errors });
  }
  validateMaxLengthpresentingfactors(name, value, max) {
    let data = this.state.caseHistory.presenting_factors_formData;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ presenting_factors_formData: data, errors: errors });
  }
  validateMaxLengthpresentingcomplaints(name, value, max) {
    let data = this.state.caseHistory.presenting_complaints_formData;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      //  errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ presenting_complaints_formData: data, errors: errors });
  }
  handlePersonalityTraits = (e) => {
    let data = this.state.caseHistory.premorbid_history;
    data.personality_traits = e.target.value;
    this.setState({ premorbid_history: data });
  };
  validateMaxLength(name, value, max) {
    let data = this.state.caseHistory.socio_demographic_formData;
    let errors = this.state.errors;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      //  errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {

      data[name] = value;
    }
    this.setState({ socio_demographic_formData: data, errors: errors });
  }
  // addSocioDemographicDetail() {
  //   let formData = this.state.socio_demographic_formData;
  //   formData.type = "addSocioDemographic";
  //   let { socio_demographic_error } = this.state;
  //   socio_demographic_error = Validation(formData, socio_demographic_error);
  //   this.setState({ socio_demographic_error: socio_demographic_error });

  //   if (socio_demographic_error.formIsValid) {
  //     let records = this.state.socio_demographic_details;
  //     let record = "";
  //     if ("" === formData.id) {
  //       let record = Object.assign({}, socio_demographic_record);
  //       record.id = getMaxIdOfRecords(records);

  //       if (records.length > 0) {
  //         let maxId = Math.max.apply(
  //           Math,
  //           records.map(function (o) {
  //             return o.id;
  //           })
  //         );
  //         record.s_no = maxId + 1;
  //       } else {
  //         record.s_no = records.length + 1;
  //       }
  //       record.education_level = formData.education_level;
  //       record.occupation = formData.occupation;
  //       record.living_situation = formData.living_situation;
  //       record.s_no = records.length + 1;
  //       console.log(record);
  //       records.push(record);
  //     } else {
  //       const updateRecordIndex = records
  //         .map((item) => item.id)
  //         .indexOf(formData.id);
  //       let record = records[updateRecordIndex];
  //       record.education_level = formData.education_level;
  //       record.occupation = formData.occupation;
  //       record.living_situation = formData.living_situation;
  //     }

  //     let initalData = Object.assign({}, socio_demographic_record);
  //     this.setState({
  //       socio_demographic_formData: initalData,
  //       medAction: "",
  //       medEdit: false,
  //     });
  //   }
  // }
  cancelAddEdit(tableName, e) {
    let initalData = "";
    if ("education" === tableName) {
      initalData = Object.assign({}, eq_record);
      this.setState({
        educational_qualification_formData: initalData,
        edAction: "",
        edEdit: false,
      });
    } else if ("certificate" === tableName) {
      initalData = Object.assign({}, cert_record);
      this.setState({
        certifications_formData: initalData,
        certAction: "",
        certEdit: false,
      });
    } else if ("experience" === tableName) {
      initalData = Object.assign({}, experience_record);
      this.setState({
        experiences_formData: initalData,
        exAction: "",
        exEdit: false,
      });
    } else if ("medicalLicence" === tableName) {
      initalData = Object.assign({}, socio_demographic_record);
      this.setState({
        socio_demographic_formData: initalData,
        medAction: "",
        medEdit: false,
      });
    }
  }
  // editMedicalRecord(record) {
  //   let dataObj = this.state.caseHistory.socio_demographic_formData;
  //   dataObj.id = record.id;
  //   dataObj.education_level = record.education_level;
  //   dataObj.occupation = record.occupation;
  //   dataObj.living_situation = record.living_situation;
  //   console.log(dataObj);
  //   this.setState({ socio_demographic_formData: dataObj });
  // }
  handleSocioDemographicInputChange = (e) => {
    let data = this.state.caseHistory.socio_demographic_formData;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;

    if (
     
      name === "living_situation"


    ) {
      this.validateMaxLengthforsociodemographic(name, value, max);
    } else {
      data[name] = value;
    }

    this.setState({ socio_demographic_formData: data });


  };

  handleMentalStatusExaminationInputChange = (e) => {
    let data = this.state.caseHistory.mental_status_examination;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "appearence" ||
      name === "behavior" ||
      name === "mood" ||
      name === "thought_content"||
       name === "perception"||
        name === "cognition_orientation"


    ) {
      this.validateMaxLengthmentalstatusexamination(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ mental_status_examination: data });
  };
  validateMaxLengthmentalstatusexamination(name, value, max) {
    let data = this.state.caseHistory.mental_status_examination;
    // let errors = this.state.socio_demographic_error;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      //  errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      // errors[name] = "";
      data[name] = value;
    }
    this.setState({ mental_status_examination: data });
  }

  handlePrognosticFactorsInputChange = (e) => {
    let data = this.state.caseHistory.prognostic_factors;
    let name = e.target.name;
    let value = e.target.value;
    let max = e.target.max;
    if (
      name === "severity_and_duration_of_symptoms" ||
      name === "response_to_previous_treatments" ||
      name === "support_systems_available" ||
      name === "comorbid_conditions"


    ) {
      this.validateMaxLengthPrognosticfactors(name, value, max);
    } else {
      data[name] = value;
    }
    this.setState({ prognostic_factors: data });
  };
  validateMaxLengthPrognosticfactors(name, value, max) {
    let data = this.state.caseHistory.prognostic_factors;
    // let errors = this.state.socio_demographic_error;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      //  errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      // errors[name] = "";
      data[name] = value;
    }
    this.setState({ prognostic_factors: data });
  }
  submitCaseHistory() {
    axios.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${this.props.access_token}`;
    console.log(this.props.id)
    const checkinData = { id: this.props.id };

    axios
      .post(getCheckinDetails, checkinData, CONFIG)
      .then((res) => {
        let data = res.data.data || res.data.date;
        if (res.data.status !== "1" || !data) {
          return;
        }


        console.log(res.data.status)
        this.setState({
          checkindetails: res.data.data,
          client_id: this.state.checkindetails.client_id,
          business_id: this.state.checkindetails.business_id,
          business_user_id: this.state.checkindetails.business_user_id,

        });
        console.log(this.state.checkindetails);
        console.log(this.state.checkindetails.client_id);
        let caseHistory = this.state.caseHistory;
        caseHistory.id = this.props.id;
        caseHistory.client_id = this.state.checkindetails.client_id;
        caseHistory.business_id = this.state.checkindetails.business_id;
        caseHistory.business_user_id = this.state.checkindetails.business_user_id;
        let newdata = Object.assign({}, caseHistory);
        newdata.socio_demographic_formData = caseHistory.socio_demographic_formData;
        newdata.presenting_complaints_formData = caseHistory.presenting_complaints_formData;
        newdata.presenting_factors_formData = caseHistory.presenting_factors_formData;
        newdata.past_treatment_history = caseHistory.past_treatment_history;
        newdata.family_history = caseHistory.family_history;
        newdata.developmental_history = caseHistory.developmental_history;
        newdata.premorbid_history = caseHistory.premorbid_history;
        newdata.preciptating_history = caseHistory.preciptating_history;
        newdata.perpetuating_factors = caseHistory.perpetuating_factors;
        newdata.prognostic_factors = caseHistory.prognostic_factors;
        newdata.mental_status_examination = caseHistory.mental_status_examination;
        newdata.case_formulation = caseHistory.case_formulation;
        console.log(newdata);
        // let postData = {};
        // postData.id = this.props.id;
        // postData.socio_demographic_details = this.state.socio_demographic_details;
        // postData.client_id = this.state.checkindetails.client_id;
        // postData.business_id = this.state.checkindetails.business_id;
        // postData.business_user_id = this.state.checkindetails.business_user_id;
        axios.defaults.headers.common[
          "Authorization"
        ] = `Bearer ${this.props.access_token}`;
        this.setState({ loading: true }, () => {
          axios
            .post(consultPsychiatristDoctor, newdata, CONFIG)
            .then((res) => {
              this.setState({ loading: false });
              const result = res.data;
              if (result.status === "1") {
                this.setState({ PrescriptionsuccessMessage: "Your Prescription details have been updated successfully." });
                  // toast.success("Your Case History details have been updated successfully.",{
                  //             className:"toast-success"
                  //           });
                  this.setState({ activeTab: "PsychiatristAssessment" })
              } else {
                this.setState({
                  PrescriptionerrorMessage:
                    result.message || "Failed to submit prescription details",
                });
              }
              this.setState({ activeTab: "PsychiatristAssessment" })

            })
            .catch((e) => {
              this.setState({
                loading: false,
                errorMessage: "Failed to submit consultant details",
                activeTab: "PsychiatristAssessment"
              });
            });


          this.clearMessage();
        });




      }).catch((e) => { });


  }

  validateMaxLengthforsociodemographic(name, value, max) {
    let data = this.state.caseHistory.socio_demographic_formData;
    let errors = this.state.socio_demographic_error;
    if (value.length > max) {
      const value1 = value.slice(0, max);
      errors[name] = "Maximum Length has exceeded.";
      data[name] = value1;
    } else {
      errors[name] = "";
      data[name] = value;
    }
    this.setState({ socio_demographic_formData: data, errors: errors });
  }
}


export default withRouter(connect(
  mapStateToProps,
)(CaseHistorypsychiatrist)
);